import { CommonModule, NgClass } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { SelectOnlyComponent } from '../select-only/select.component';

@Component({
  selector: 'ux-select-only-header',
  templateUrl: './select-only-header.component.html',
  styleUrls: ['./select-only-header.component.less'],
  imports: [NgClass, CommonModule],
  standalone: true,
  // changeDetection: ChangeDetectionStrategy.OnPush, // связносьти компонентов нет, не хочется эту связь создавать
})
export class SelectOnlyHeaderComponent implements OnInit {
  selectOnlyComponent = inject(SelectOnlyComponent);

  ngOnInit() {}
}
